import { render, staticRenderFns } from "./product-features.vue?vue&type=template&id=f837a37c&"
import script from "./product-features.vue?vue&type=script&lang=js&"
export * from "./product-features.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports